<template>
  <svg data-testid="MyLocationIcon" width="24px" height="24px" viewBox="0 0 24 24">
    <desc>Arrow Icon</desc>
    <g>
      <g>
        <path id="my-location-icon"
              d="M12.88,12.4942a2,2,0,0,0-1.3736-1.3736L6.0734,9.5682l14.24-5.8816-5.8815,
              14.24ZM14.0872,24,24,0,0,9.9128l10.9568,3.1308Z"></path>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconMyLocation',
};
</script>

<style scoped>

</style>
